<template>
<header class="bg-white header header-md navbar navbar-fixed-top-xs box-shadow">
    <div class="navbar-header aside-md dk theme-background-color">
         <a class="btn btn-link visible-xs" data-toggle="class:nav-off-screen,open" data-target="#nav,html">
            <i class="fa fa-bars"></i> 
         </a> 
                  <a href="#" class="navbar-brand"> 
            Al Nasiya 
          <span class="hidden-nav-xs" style="
                font-size: 12px;">Gen.Cont. LLC</span> 
         </a>
         <a class="btn btn-link visible-xs" data-toggle="dropdown" data-target=".user"> 
            <i class="fa fa-cog"></i> 
         </a> 
     </div>
    <ul class="nav navbar-nav hidden-xs">
        <li> 
            <a href="#nav" data-toggle="class:nav-xs" class="btn btn-icon icon-muted btn-inactive m-l-xs m-r-xs"> <i class="fa fa-outdent text"></i> <i class="fa fa-indent text-active"></i> </a>
        </li>
    </ul> 
    <ul class="nav navbar-nav navbar-right m-n hidden-xs nav-user user"> 
        <!--
        <li>
            
            <a href="" style="width: 100px;" class="btn btn-icon icon-muted btn-inactive m-l-xs m-r-xs hidden-nav-xs"><i class="fa fa-user" style="font-size: 20px;"></i> Profile</a> 
        </li>
        -->
        <li>
           
            <input type="hidden" name="userType" value="">
           
                       <a href="" @click="logout" style="width: 100px;" class="btn btn-icon icon-muted btn-inactive m-l-xs m-r-xs hidden-nav-xs"><i class="fa fa-sign-out" style="font-size: 20px;"></i> Logout</a> 
        </li>

    </ul> 
</header>
</template>



<script>

export default {
  name: 'Header',
  methods:{
    logout: function () {
        this.$store.commit('SET_USER', null);
        if (window.localStorage) {
          window.localStorage.setItem('user', null)
        }
        this.$router.push('/login');
    }
  }
}
</script>